import Header from './Header';
import Footer from './Footer';
import { Link } from 'react-router-dom';

export default function InnerLayout({ titleFirst, titleAccent, subtitle, breadcrumb, children }) {
  return (
    <div className="page inner-page">
      <Header />
      <main>
        <div className="page-hero">
          <div className="breadcrumb">
            <Link to="/">Inicio</Link>
            <span className="breadcrumb-sep">/</span>
            <span>{breadcrumb}</span>
          </div>
          <h1 className="page-title">
            {titleFirst} <span className="accent">{titleAccent}</span>
          </h1>
          {subtitle && <p className="page-subtitle">{subtitle}</p>}
        </div>
        <div className="content-section">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
}
